import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import useTranslation from 'Hooks/useTranslation';
import SideBarContainer from 'Containers/SideBarContainer';
import Title from '../../Components/Title';
import Card from '../../Components/Card';
import Alert from '../../Components/Alert';
import useInformation from './Hooks/useInformation';
import { containerMain } from './style';

export default function DefinitionCourses() {
  const { t2 } = useTranslation('DefinitionCourse');
  const { cards, handlePage } = useInformation();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (location?.state?.update) {
      setOpen(true);
    }
  }, []);

  return (
    <SideBarContainer>
      <div style={containerMain}>
        <Title title={t2('Title')} subtitle={t2('Subtitle')} centerText />
        <Container maxWidth={false} style={{ marginTop: '5rem' }}>
          <Grid container direction="row" justifyContent="space-evenly" style={{ cursor: 'pointer' }}>
            {cards.length > 0 ? (
              cards.map((card, index) => {
                const id = card + index;
                return (
                  <Grid key={id} item xs={12} md={3} onClick={() => handlePage(index)}>
                    <Card {...card} />
                  </Grid>
                );
              })
            ) : (
              <div>{t2('no_data')}</div>
            )}
          </Grid>
        </Container>
      </div>
      <Alert message={t2('OnSuccessMessage')} open={open} setOpen={setOpen} />
    </SideBarContainer>
  );
}
